'use strict';

import Api from 'services/api';

const ConfigOptionsActionCreators = {
    getOptions(personId, optionsKey) {
        Api.CONFIGURATION_OPTIONS.getOptions(personId, optionsKey);
    },
    getOptionsForApiKey(apiKey, optionsKey) {
        Api.CONFIGURATION_OPTIONS.getOptionsForApiKey(apiKey, optionsKey);
    },
};

export default ConfigOptionsActionCreators;
